import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from 'react-bootstrap/FormControl';
import { useDebouncedCallback } from 'use-debounce';
import cx from 'classnames';
import Icon from '@components/@core/Icon';

const Search = ({ className = '', placeholder = 'Search here...', hideIcon = false, onChange = () => {}, dataCy = null, type = 'Tracks', ...props }) => {
    const [value, setValue] = useState(props.initial);

    useEffect(() => {
        setValue(props.initial ?? '');
    }, [props.initial]);

    const handleDebounced = useDebouncedCallback((e) => {
        if (onChange) onChange(e);
    }, 500);

    const handleChange = (e) => {
        setValue(e.target.value);
        handleDebounced(e);
    };

    return (
        <div className={cx('ds-search', className)} data-cy={dataCy}>
            <FormControl type="text" {...props} value={value} placeholder={placeholder} onChange={handleChange} />
            {!hideIcon && <Icon name="fas fa-search" size={18} color="#343f4b" />}
        </div>
    );
};

Search.propTypes = {
    className: PropTypes.string,
    placeholder: PropTypes.string,
    hideIcon: PropTypes.bool,
    dataCy: PropTypes.any,
    onChange: PropTypes.func,
};

export default Search;
